import HomePage from './containers/HomePage';
import SearchPage from './containers/SearchPage';
import TitleContainer from './containers/TitleContainer';
import PersonContainer from './containers/PersonContainer';
import Auth from './containers/Auth/Auth';
import UserDashboard from './containers/UserDashboard/UserDashboard';
import LogOut from './containers/LogOut/LogOut';

export default [
  {
    path: '/user/:id',
    component: UserDashboard,
  },
  {
    path: '/search/:id',
    component: SearchPage,
  },
  {
    path: '/search',
    component: SearchPage,
  },
  {
    path: '/person/:id',
    component: PersonContainer,
  },
  {
    path: '/:type/:id',
    component: TitleContainer,
  },
  {
    path: '/logout',
    component: LogOut,
  },
  {
    path: '/login',
    component: Auth,
  },
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/user',
    component: UserDashboard,
  },
];